<template>
  <!-- 一级菜单 -->
  <div class="smy__first-menu-box">
    <div class="logo"></div>
    <div
      class="first-menu"
      :class="{ 'first-menu-check': menu.id == firstMenu }"
      @click="_firstMenu(menu.id)"
      v-for="menu in firstMenuList"
      :key="menu.oldKey"
    >
      <div :class="{ 'menu-shade': menu.id == firstMenu }"></div>
      <Icon
        type="arrow-left-b"
        class="arrow"
        size="20"
        v-show="menu.id == firstMenu"
      ></Icon>
      <div class="menu-icon">
        <Icon :type="menu.icon"></Icon>
      </div>
      <div class="menu-name">
        {{ menu.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('menu', ['firstMenu', 'firstMenuList']),
  },
  methods: {
    ...mapMutations('menu', ['_firstMenu']),
  },
}
</script>

<style lang="less" scoped>
@import '../assets/whole';

.smy__first-menu-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60px;
  background: -webkit-linear-gradient(
    @primary-color,
    @nav-color
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    @primary-color,
    @nav-color
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    @primary-color,
    @nav-color
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(@primary-color, @nav-color); /* 标准的语法 */
  padding-top: 5px;
  z-index: 99;

  .logo {
    width: 50px;
    height: 55px;
    background-image: url('../assets/img/logo.png');
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .first-menu:hover {
    cursor: pointer;
    color: #fff;
  }

  .first-menu {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 50px;
    color: #d1f2e1;

    .menu-icon {
      line-height: 22px;
      font-size: 20px;
    }

    .menu-name {
      margin-top: 5px;
      line-height: 12px;
      font-size: 12px;
    }

    .menu-shade {
      background: #333;
      opacity: 0.05;
      width: 60px;
      height: 50px;
      position: absolute;
      top: 0px;
    }
  }

  .first-menu-check {
    color: #fff;
  }

  .arrow {
    position: absolute;
    left: 53px;
    top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FirstMenu.vue